import axios from 'axios';
import ACTION_ITEMS from '../actionItems';

export function postLoginUser(data) {
  return (dispatch) => {
    axios.post('/login', {
      username: data.username,
      password: data.password
    }).then(function (response) {
      if (response.data.message) {
        dispatch(postLoginUserFailure(response.data.message));
      } else {
        postLoginUserSuccess();
      }
    }).catch(function (error, response) {
      console.error(error);
    });
  };
};

function postLoginUserSuccess() {
  window.location = '/categories';
}

function postLoginUserFailure(message) {
  return {
    type: ACTION_ITEMS.LOGIN.FAILURE,
    payload: {
      message: message
    }
  };
}



// WEBPACK FOOTER //
// ./src/pages/login/components/loginForm/actions/postLoginUser.js